var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5_177",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 11,
    height: 11,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 11,
    height: 11,
    rx: 1,
    stroke: "#3F647A",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_5_177)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_5_177",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 11,
    height: 11,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 11,
    height: 11,
    rx: 1,
    stroke: "#3F647A",
    strokeWidth: 3,
    mask: "url(#path-2-inside-2_5_177)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_5_177",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 11,
    height: 11,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 11,
    height: 11,
    rx: 1,
    stroke: "#3F647A",
    strokeWidth: 3,
    mask: "url(#path-3-inside-3_5_177)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_5_177",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    rx: 1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    rx: 1,
    stroke: "#3F647A",
    strokeWidth: 3,
    mask: "url(#path-4-inside-4_5_177)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboad);
export default __webpack_public_path__ + "static/media/dashboad.54412c658fe74666c05dcc5469983cf4.svg";
export { ForwardRef as ReactComponent };